import React, { useEffect, useState } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { autenticarUsuario } from '../../services/http/autenticarService'
import { trackPromise } from 'react-promise-tracker';
import services from '../../services';
import cookies from 'js-cookie';



const PageAutenticacao = () => {
  const history = useHistory();
  const [token, setToken] = useState('');

  const Autenticar = () => {
    cookies.set('token', token);
    history.push('/login-integracao');
  }

  return (
    <div className="row container mt-5">
      <div className="col-md-6">
        <div>
          <input type="text" className="form-control" id="exampleInputEmail1" onChange={(e) => setToken(e.target.value)} aria-describedby="emailHelp" />
        </div>
      </div>
      <div className="col-md-6">
        <button type="button" className="btn btn-primary" onClick={() => Autenticar()}>Autenticar</button>
      </div>
    </div>
  )
}

export default PageAutenticacao;